export const RESTRICTED_YEARS = [2020];
